<section>
  <onyx-information-heading>
    {{ 'labels.details' | translate }}
  </onyx-information-heading>

  <onyx-information-list>
    @let author = order().author;
    <onyx-information-row label="labels.orderAuthor">
      <span>{{ author | onyxName }}</span>
    </onyx-information-row>

    <onyx-information-row label="labels.additionDate">
      {{
        order().timestamps.createdAt
          | onyxDate: 'date-dot-time' : { separator: ' · ' }
      }}
    </onyx-information-row>

    @if (order().basicInformation.referenceNumber; as referenceNumber) {
      <onyx-information-row label="labels.orderReferenceNumber">
        {{ referenceNumber }}
      </onyx-information-row>
    }
  </onyx-information-list>
</section>

@if (order().outsourcingData; as outsourcingData) {
  <section>
    <onyx-information-heading>
      <div class="outsourcing-heading">
        <onyx-icon name="cursor-filled" [size]="20"></onyx-icon>

        {{ 'labels.outsourcing' | translate }}
      </div>
    </onyx-information-heading>

    <onyx-information-list>
      <div class="outsourcing">
        <div class="information-row">
          <div class="item f-paragraph-m f-semibold">
            <p class="f-muted f-body-s f-medium">
              {{ 'labels.sellRate' | translate }}
            </p>

            {{ outsourcingData.rate | onyxAmount: 'value' : false }}
          </div>

          <div class="item f-paragraph-m f-semibold">
            <p class="f-muted f-body-s f-medium">
              {{ 'labels.margin' | translate }}
            </p>

            <div class="amount">
              {{ outsourcingData.marginRate | onyxAmount: 'value' : false }}
              ({{ outsourcingData.marginPercentage / 100 | number: '1.0-1' }}%)
            </div>
          </div>

          <div class="item f-paragraph-m f-semibold">
            <p class="f-muted f-body-s f-medium">
              {{ 'labels.paymentTerm' | translate }}
            </p>

            {{ outsourcingData.paymentTerm | onyxDate: 'date' }}
          </div>
        </div>
      </div>

      @let I18N_OUTSOURCING_FORM = 'orders.orderModal.outsourcingForm';
      @let executionTerms = outsourcingData.executionTerms;
      <onyx-data-widget
        [supheading]="
          executionTerms
            ? `${I18N_OUTSOURCING_FORM}.executionTerms`
            : 'labels.missingExecutionTerms'
        "
      >
        @if (executionTerms) {
          <p class="execution-terms">{{ executionTerms }}</p>
        }
      </onyx-data-widget>
    </onyx-information-list>
  </section>
}

@let vehicleRequirements = parameters().vehicleRequirements;
@if (vehicleRequirements.length) {
  <section>
    <onyx-information-heading>
      {{ 'labels.vehicleRequirements' | translate }}
    </onyx-information-heading>

    <onyx-information-list>
      @for (requirement of vehicleRequirements; track requirement) {
        <onyx-information-row [label]="requirement.name | translate">
          @let value = $any(requirement.value);
          @if (value === true) {
            {{ 'labels.yes' | translate }}
          } @else {
            @switch (requirement.key) {
              @case ('adrClasses') {
                @for (class of value; track class) {
                  {{ `${DictionaryCode.ADR_CLASS}.${class}` | translate }}
                }
              }
              @case ('temperatureRange') {
                {{ value | onyxTemperature }}
              }
              @case ('minSemiTrailerSize') {
                <div class="trailer-requirements">
                  <onyx-icon
                    [name]="semiTrailerSizeIcon()"
                    [size]="16"
                  ></onyx-icon>

                  {{
                    `${DictionaryCode.ORDER_SEMI_TRAILER_SIZE}.${value}`
                      | translate
                  }}
                </div>
              }
              @case ('dischargeTypes') {
                {{
                  value
                    | join
                      : { maxLength: 5, i18nKey: DictionaryCode.DISCHARGE_TYPE }
                }}
              }
              @case ('cargoSpace') {
                {{
                  value
                    | join
                      : { maxLength: 5, i18nKey: DictionaryCode.VEHICLE_TYPE }
                }}
              }
              @case ('minEmissionStandard') {
                {{ `${DictionaryCode.EMISSION_STANDARD}.${value}` | translate }}
              }
              @case ('fuelTypes') {
                {{
                  value
                    | join
                      : {
                          maxLength: 2,
                          i18nKey: DictionaryCode.FUEL_TYPE,
                        }
                }}
              }
              @case ('otherVehicleParameters')
              @case ('otherDriverPermissions') {
                @for (parameter of value; track parameter.uuid) {
                  {{ parameter.names | onyxLanguage }}{{ !$last ? ',' : '' }}
                }
              }
              @default {
                {{ value }}
              }
            }
          }
        </onyx-information-row>
      }
    </onyx-information-list>
  </section>
}

@let driverRequirements = parameters().driverRequirements;
@if (driverRequirements.length) {
  <section>
    <onyx-information-heading>
      {{ 'labels.driverRequirements' | translate }}
    </onyx-information-heading>

    <onyx-information-list>
      @for (requirement of driverRequirements; track requirement) {
        <onyx-information-row [label]="requirement.name | translate">
          @let value = $any(requirement.value);
          @if (value === true) {
            {{ 'labels.yes' | translate }}
          } @else {
            {{
              value | join: { maxLength: 4, i18nKey: DictionaryCode.LANGUAGE }
            }}
          }
        </onyx-information-row>
      }
    </onyx-information-list>
  </section>
}

@let otherRequirements = parameters().otherRequirements;
@if (otherRequirements.length) {
  <section>
    <onyx-information-heading>
      {{ 'labels.otherRequirements' | translate }}
    </onyx-information-heading>

    <onyx-information-list>
      @for (requirement of otherRequirements; track requirement) {
        <onyx-information-row [label]="requirement.name | translate">
          @let value = $any(requirement.value);
          @if (value === true) {
            {{ 'labels.yes' | translate }}
          } @else {
            {{ value }}
          }
        </onyx-information-row>
      }
    </onyx-information-list>
  </section>
}
